import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'image-modal',
    template: require('./image-modal.template.html')
})

export class ImageModalComponent {

    @ViewChild('modal') childModal: ModalDirective;

    title: string;

    imageUrl: string;


    show(title: string, imageUrl: string): void {
        this.imageUrl = imageUrl;
        this.title = title;
        this.childModal.show();
    }

    onHide(): void {
        this.childModal.hide();
    }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/image-modal.component.ts